import React from 'react';

// The tax basis ("ex GST" / "inc GST") under a money column's heading, on
// a line of its own, small and grey, no brackets — so a narrow column never
// wraps mid-phrase (ui-architecture.md "Tax Basis in Column Headings").
// Renders nothing when there's no basis to show (GST not applicable).
export default function TaxBasisLine({ children }) {
  if (!children) return null;
  return <div style={{ fontSize: 11, fontWeight: 400, color: '#8a94a6' }}>{children}</div>;
}
